import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";
import ContactInquiryAside from "@/components/contact/ContactInquiryAside";
import ContactInquiryForm from "@/components/contact/ContactInquiryForm";
import "./ContactInquiryModal.css";

export default function ContactInquiryModal({ open, onOpenChange, formKey = 0 }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="contact-dialog"
        overlayClassName="ds-contact-dialog-overlay"
        closeClassName="right-0 top-0 flex h-9 w-9 translate-x-[calc(100%+0.625rem)] -translate-y-[calc(100%+0.625rem)] items-center justify-center rounded-full border border-white/25 bg-[#0a0a0a] text-white opacity-100 shadow-lg hover:bg-white/10 hover:opacity-100 focus:ring-white/30 [&_svg]:h-5 [&_svg]:w-5"
        className="max-w-[min(96vw,68rem)] max-h-[min(90vh,820px)] overflow-visible border-white/10 bg-[#050505] p-0 text-white sm:rounded-2xl"
      >
        <DialogTitle className="sr-only">프로젝트 문의하기</DialogTitle>
        <DialogDescription className="sr-only">
          프로젝트 상담을 위한 문의 양식입니다.
        </DialogDescription>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-5 p-4 md:p-5 max-h-[min(90vh,820px)] overflow-y-auto lg:items-stretch">
          <div className="lg:col-span-4 flex min-h-0 self-stretch">
            <ContactInquiryAside compact modal />
          </div>
          <div className="lg:col-span-8 min-h-0 self-stretch">
            {open ? (
              <ContactInquiryForm key={`contact-modal-${formKey}`} active compact />
            ) : null}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
